import { FormUnit } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import { useNextLoading, useOnNextClick } from '@/providers'
import { useTranslation } from 'react-i18next'
import { useSaveAssessmentStep } from '../helpers'
import { JSX } from 'react'

interface Messages {
  inventoryHelperText: string
  placeholder: string
}

const useMessages = (): Messages => {
  const { t } = useTranslation()

  return {
    inventoryHelperText: t('inventoryHelperText'),
    placeholder: t('currencyInputPlaceholder'),
  }
}

export const InventoryStep = (): JSX.Element => {
  const messages = useMessages()
  const { save, isLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.inventory,
  )

  useOnNextClick(save)

  useNextLoading(() => isLoading, [isLoading])

  return (
    <FormUnit
      helperText={messages.inventoryHelperText}
      name="totalEquipmentsCost"
      placeholder={messages.placeholder}
      unit="€"
    />
  )
}
